import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Remote } from 'comlink';
import type { Highlighter } from '@/workers/highlighter/highlighter';

export const useHighlighterStore = defineStore('highlighter', () => {
    let highlighterObj: Remote<Highlighter>;
    const isInitialized = ref(false);
    const isLoading = ref(false);
    let initialization: null | Promise<void> = null;

    async function init() {
        if (typeof Worker === 'undefined') {
            return;
        }
        if (isInitialized.value || isLoading.value) {
            return initialization;
        }
        initialization = (async () => {
            isLoading.value = true;
            const highlighterLink = await import('@/workers/highlighter/link');
            if (highlighterLink) {
                highlighterObj = await highlighterLink.highlighter;
                await highlighterObj.init();
            }
            isInitialized.value = true;
            isLoading.value = false;
        })();
        await initialization;
    }

    function highlighter(): Remote<Highlighter> {
        return highlighterObj;
    }

    return {
        isInitialized,
        isLoading,
        init,
        highlighter
    };
});
